<template>
  <div :class="classObj" class="app-wrapper">
    <sidebar class="sidebar-container" />
    <div :class="{hasTagsView:needTagsView}" class="main-container" @click="MBtoggles">
      <div :class="{'fixed-header':true}">
        <navbar />
        <tags-view v-if="needTagsView" @refresh-view="refreshView" />
      </div>
      <app-main ref="appMain" />
      <!-- <right-panel>
        <settings />
      </right-panel>-->
    </div>
  </div>
</template>

<script>
import rightPanel from "@/components/common/rightPanel";
import { appMain, sidebar, tagsView, navbar, settings } from "./common";
export default {
  components: {
    rightPanel,
    appMain,
    sidebar,
    tagsView,
    navbar,
    settings,
  },
  computed: {
    needTagsView() {
      return this.$store.state.settings.tagsView;
    },
    classObj() {
      var sidebar = this.$store.state.app.sidebar;
      return {
        hideSidebar: !sidebar.opened,
        openSidebar: sidebar.opened,
        withoutAnimation: sidebar.withoutAnimation,
      };
    },
  },
  methods: {
    refreshView(name) {
      this.$refs.appMain.refreshView(name);
    },
    MBtoggles() {
      if (this.$store.state.isMB) {
        this.$store.dispatch("MBtoggleSideBar");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.content {
  padding: 10px;
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  // min-width: 1300px;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
  @media screen and (max-width: 767px) {
    width: 100%;
  }
}

.mobile .fixed-header {
  width: 100%;
}
</style>
